import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

export const ATTRIBUTE_TYPE = {
  UNSPECIFIED: 'UNSPECIFIED',
  CHECKED_BAGGAGE: 'CHECKED_BAGGAGE',
  CABIN_BAGGAGE: 'CABIN_BAGGAGE',
  CREDIT_CARDS: 'CREDIT_CARDS',
} as const;

export type AttributeType = Values<typeof ATTRIBUTE_TYPE>;
export type ValidAttributeType = Exclude<AttributeType, 'UNSPECIFIED'>;
